import { PURCHASE_DEFAULT_LABEL } from '@/components/purchase/purchase-yes-no-switcher/purchase-yes-no-switcher';

export default {
  data() {
    return {
      PURCHASE_DEFAULT_LABEL,
    };
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    layout: {
      type: String,
      default: '',
    },
  },
  computed: {
    classModifiers() {
      return {
        'button-price': true,
        [`button-price--${this.layout}`]: this.layout,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/v2/button-price/button-price.js